import { NEXT_PUBLIC_GRAPHQL_API } from '@env';

import { GraphQLClient } from 'graphql-request';

/**
 * Create an instance of the `GraphQLClient` from `graphql-request` with auth
 * header when a token is provided.
 * @param token user's auth token, probably from a cookie.
 */
export function getGraphQLClient(token?: string) {
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
  return new GraphQLClient(NEXT_PUBLIC_GRAPHQL_API, { headers });
}
